export const JOIN_ERROR_UNAUTHORIZED =
  "You don't have subscription to the course. Please download the app to buy a subscription or activate a trial";

export const JOIN_CONFIRMATION_MESSAGE = "Confirm to join";

export const CANCEL_CONFIRMATION_MESSAGE = "Are you sure you want to cancel?";
